import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useEffectOnce } from '@genially/ui/src/hooks/useEffectOnce';

import { useLogRocketService } from '../../../../../../bootstrap/application/components/app/Routes/hooks/useLogRocketService';
import { useSnowplowService } from '../../../../../../shared/application/hooks/useSnowplow';
import { PlayerGeniallyView } from '../shared/PlayerGeniallyView/PlayerGeniallyView';
import { PlayerPlaySidebarSummary } from './components/PlayerPlaySidebarSummary/PlayerPlaySidebarSummary';
import { PlayerGameProvider } from './PlayerGame.context';
import { Wrapper } from './PlayerGame.styled';

export const PlayerGame = observer(() => {
  const { trackWithSampling } = useLogRocketService();

  const { sendPlayerSessionJoinedEvent } = useSnowplowService();

  useEffectOnce(() => {
    sendPlayerSessionJoinedEvent('in-game');
  });

  useEffect(() => {
    trackWithSampling('play_participant', 10);
  }, [trackWithSampling]);

  return (
    <Wrapper>
      <PlayerGameProvider>
        <PlayerGeniallyView />
        <PlayerPlaySidebarSummary />
      </PlayerGameProvider>
    </Wrapper>
  );
});
